import { FIRE_SIGHT_FIRE_OBJECT_PRODUCT_CODE } from '../../constants/fire-sight.constants';
import {
  IFireSightAsset,
  IFireSightObservation,
} from '../../interfaces/fire-sight/IFireSightModels';

export function resolveFireSightFireObjectAsset(
  observation: IFireSightObservation | null | undefined,
): IFireSightAsset | null {
  return (
    observation?.assets.find(
      (asset) =>
        asset.product_code === FIRE_SIGHT_FIRE_OBJECT_PRODUCT_CODE &&
        asset.s3_uri.trim().length > 0,
    ) ?? null
  );
}

export function hasFireSightFireObject(
  observation: IFireSightObservation | null | undefined,
): boolean {
  return resolveFireSightFireObjectAsset(observation) !== null;
}
